import { Link } from "react-router";
import { ArrowRight, Camera, ListChecks, Mail } from "lucide-react";
import {
  Body,
  Card,
  CardTitle,
  PageHeader,
  Subtitle,
} from "@/components/ui";

type ConfigEntry = {
  to: string;
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
};

const ENTRIES: ReadonlyArray<ConfigEntry> = [
  {
    to: "/configuration/asset-types",
    title: "Asset-types",
    description:
      "Beheer welke types van assets je kan inzetten (camera, mobile tree, …) en hun labels.",
    icon: Camera,
  },
  {
    to: "/configuration/email-templates",
    title: "E-mail templates",
    description:
      "Standaardteksten voor communicatie met aanvragers en plaatsingsfirma's.",
    icon: Mail,
  },
  {
    to: "/configuration/task-templates",
    title: "Taken templates",
    description:
      "Sjablonen met standaardtaken die je in één klik kan toepassen op een dossier.",
    icon: ListChecks,
  },
];

export function ConfigurationPage(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Configuratie"
        subtitle="Beheer asset-types, e-mail templates en taken templates voor het hele platform."
      />

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {ENTRIES.map((entry) => {
          const Icon = entry.icon;
          return (
            <Card key={entry.to} padding="lg" interactive asChild>
              <Link to={entry.to} className="flex h-full flex-col gap-3">
                <div className="flex items-center gap-3">
                  <span className="inline-flex size-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <Icon className="size-5" />
                  </span>
                  <CardTitle>{entry.title}</CardTitle>
                </div>
                <Body tone="muted" className="flex-1">
                  {entry.description}
                </Body>
                <Subtitle className="inline-flex items-center gap-1 text-primary-700">
                  Beheren
                  <ArrowRight className="size-4" aria-hidden />
                </Subtitle>
              </Link>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
